module.exports = __webpack_public_path__ + "img/0b7f96c.webp";